/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { NotificationTargetGroupEnumType } from './NotificationTargetGroupEnum'
import { TournamentDifficultyEnumType } from './TournamentDifficultyEnum'
import { RootStoreType } from './index'

/**
 * TournamentScheduleBase
 * auto generated base class for the model TournamentScheduleModel.
 */
export const TournamentScheduleModelBase = ModelBase.named('TournamentSchedule')
  .props({
    __typename: types.optional(types.literal('TournamentSchedule'), 'TournamentSchedule'),
    _id: types.identifier,
    actionTime: types.union(types.undefined, types.null, types.number),
    bigBlind: types.union(types.undefined, types.null, types.number),
    blindTimer: types.union(types.undefined, types.null, types.number),
    createdAt: types.union(types.undefined, types.frozen()),
    difficulty: types.union(types.undefined, types.null, TournamentDifficultyEnumType),
    maxPlayers: types.union(types.undefined, types.null, types.number),
    name: types.union(types.undefined, types.string),
    notificationTargetGroup: types.union(types.undefined, types.null, NotificationTargetGroupEnumType),
    numberOfTables: types.union(types.undefined, types.null, types.number),
    scheduleStartTime: types.union(types.undefined, types.null, types.frozen()),
    smallBlind: types.union(types.undefined, types.null, types.number),
    startDayOfWeekUTC: types.union(types.undefined, types.number),
    startHoursUTC: types.union(types.undefined, types.number),
    startMinutesUTC: types.union(types.undefined, types.number),
    startingChips: types.union(types.undefined, types.null, types.number),
    updatedAt: types.union(types.undefined, types.frozen()),
    usersToNotify: types.union(types.undefined, types.null, types.array(types.string))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TournamentScheduleModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get actionTime() {
    return this.__attr('actionTime')
  }
  get bigBlind() {
    return this.__attr('bigBlind')
  }
  get blindTimer() {
    return this.__attr('blindTimer')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get difficulty() {
    return this.__attr('difficulty')
  }
  get maxPlayers() {
    return this.__attr('maxPlayers')
  }
  get name() {
    return this.__attr('name')
  }
  get notificationTargetGroup() {
    return this.__attr('notificationTargetGroup')
  }
  get numberOfTables() {
    return this.__attr('numberOfTables')
  }
  get scheduleStartTime() {
    return this.__attr('scheduleStartTime')
  }
  get smallBlind() {
    return this.__attr('smallBlind')
  }
  get startDayOfWeekUTC() {
    return this.__attr('startDayOfWeekUTC')
  }
  get startHoursUTC() {
    return this.__attr('startHoursUTC')
  }
  get startMinutesUTC() {
    return this.__attr('startMinutesUTC')
  }
  get startingChips() {
    return this.__attr('startingChips')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get usersToNotify() {
    return this.__attr('usersToNotify')
  }
}
export function selectFromTournamentSchedule() {
  return new TournamentScheduleModelSelector()
}

export const tournamentScheduleModelPrimitives =
  selectFromTournamentSchedule()._id.actionTime.bigBlind.blindTimer.createdAt.difficulty.maxPlayers.name
    .notificationTargetGroup.numberOfTables.scheduleStartTime.smallBlind.startDayOfWeekUTC.startHoursUTC.startMinutesUTC
    .startingChips.updatedAt.usersToNotify
